import Image from 'next/image';

import ImageAbout from './assets/about.png';

import IconAnotherWindow from '@public/new-icons/icon/icon_another-window.svg';

export const About = () => {
  return (
    <div className='item-center flex flex-col items-center gap-14 py-14'>
      <p className='text-title-strong-medium text-accent'>東北社会起業家コミュニティ</p>
      <div className='flex flex-col items-center gap-8 lg:flex-row'>
        <Image src={ImageAbout} alt='about' width={400} />
        <div className='flex flex-col gap-4 px-4 lg:px-0'>
          <p className='body-medium max-w-[528px] px-4'>
            INTILAQは、「起業家育成・⽀援」を⽬的とした活動です。起業家のみならず、⼩中⾼⽣、⼤学⽣、主婦の⽅も含め新しいことにチャレンジする「マインドの育成」、アイデアやビジネスチャンス創出のための「きっかけの場づくり」、そしてオフィスや資⾦提供まで、総合的に「ココロイキルヒト」を⽀援しています。
            <br />
            様々なプログラムやイベントを通じて東北のソーシャルイノベーションを促進するコミュニティが広がっています。
          </p>
          <div className='flex flex-row items-center gap-2'>
            <IconAnotherWindow />
            <a
              href='https://www.social-ignition.net/leaders'
              target='_blank'
              rel='noreferrer'
              className='text-title-strong-x-small text-accent'
            >
              ココロイキルヒトリーダーズ
            </a>
          </div>
          <div className='flex flex-row items-center gap-2'>
            <IconAnotherWindow />
            <a
              href='https://www.social-ignition.net/sia'
              target='_blank'
              rel='noreferrer'
              className='text-title-strong-x-small text-accent'
            >
              Social Impact Accelerator(SIA)プログラム
            </a>
          </div>
          <div className='flex flex-row items-center gap-2'>
            <IconAnotherWindow />
            <a
              href='https://www.social-ignition.net/seed-programslc'
              target='_blank'
              rel='noreferrer'
              className='text-title-strong-x-small text-accent'
            >
              Seed program for Local Challenger（SLC）プログラム
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
